import type {
  EffectMetamodelManifestSpec,
  FieldMetamodelManifestSpec,
  MetamodelGraphqlMutation,
  ModelMetamodelManifestSpec,
} from "@granular-software/metamodel-core";
import { DEFAULT_METAMODEL_PACKAGES } from "@granular-software/metamodel-preset-default";

export function buildFieldMetamodelMutations(
  fieldPath: string,
  spec: FieldMetamodelManifestSpec,
): MetamodelGraphqlMutation[] {
  return DEFAULT_METAMODEL_PACKAGES.flatMap(
    (pkg) => pkg.manifest?.buildFieldMutations?.(fieldPath, spec) || [],
  );
}

export function buildModelMetamodelMutations(
  modelPath: string,
  spec: ModelMetamodelManifestSpec,
): MetamodelGraphqlMutation[] {
  return DEFAULT_METAMODEL_PACKAGES.flatMap(
    (pkg) => pkg.manifest?.buildModelMutations?.(modelPath, spec) || [],
  );
}

export function buildEffectMetamodelMutations(
  toolPath: string,
  spec?: EffectMetamodelManifestSpec,
): MetamodelGraphqlMutation[] {
  if (!spec) return [];
  return DEFAULT_METAMODEL_PACKAGES.flatMap(
    (pkg) => pkg.manifest?.buildEffectMutations?.(toolPath, spec) || [],
  );
}
